@if (form) {
	<div class="page-layout-small only-width">
		<div class="flex column end margin-top">
			<button type="submit" class="radius-bottom-none" [disabled]="form.invalid">
				<mat-icon class="small margin-right-smallest">save</mat-icon>
				Create order
			</button>
		</div>
	</div>

	<div class="page-layout-small">
		<form [formGroup]="form" (ngSubmit)="confirmOrderInfo()">
			<div class="bg-light-blue padding-large">
				<div class="flex margin-bottom">
					<div class="flex-1 flex center">
						<h4>Order Info</h4>
					</div>
				</div>
				<div class="flex center">
					<div class="flex column">
						<b>Order ID</b>
						<div class="min-width margin-top-smallest bg-primary white padding-small">
							<h4>{{ form.get('orderId')?.value || '-' }}</h4>
						</div>
					</div>

					<div class="flex column margin-left-large">
						<b>Status</b>
						<div class="flex margin-top-smallest">
							<div class="min-width bg-white padding-small">
								<h4 class="normal primary">{{ form.get('statusName')?.value || 'Draft' }}</h4>
							</div>
							<button type="button" class="radius-left-none" (click)="openChangeStatusModal()">
								<i class="fa fa-solid fa-repeat"></i>
								Change
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="padding-large">
				<div class="flex">
					<div class="flex-1 margin-right-large flex column">
						<div class="flex center between">
							<b>Photographer</b>
							<button type="button" class="radius-bottom-none" (click)="openChangePhotographerModal()">
								<i class="fa-solid fa-edit"></i>
								Edit
							</button>
						</div>
						<div class="border padding flex center">
							@if (form.get('photographerName')?.value) {
								<div class="placeholder bg-primary white">
									<i class="fa fa-user"></i>
								</div>
								<div class="flex column margin-left-small">
									<input type="text" class="border-none bold padding-none" readonly formControlName="photographerName" />
									<div class="flex center primary hover margin-top-smallest">
										View Details
										<i class="fa-solid fa-arrow-up-right-from-square margin-left-smallest"></i>
									</div>
								</div>
							} @else {
								<span class="grey">Select a photographer</span>
							}
						</div>

						<div class="flex column margin-top">
							<b>
								Creation date
								<i class="margin-left-smallest fa fa-lock grey"></i>
							</b>
							<div class="flex margin-top-smallest disabled">
								<input type="text" class="flex-1" [matDatepicker]="creationDatePicker" formControlName="creationDate" matInput />
								<mat-datepicker #creationDatePicker></mat-datepicker>
								<button class="radius-left-none" (click)="creationDatePicker.open()">
									<mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
									Edit
								</button>
							</div>
						</div>

						<div class="flex column margin-top">
							<b>Due date</b>
							<div class="flex margin-top-smallest">
								<input type="text" class="flex-1" [matDatepicker]="dueDatePicker" formControlName="dueDate" matInput />
								<mat-datepicker #dueDatePicker></mat-datepicker>
								<button class="radius-left-none" (click)="dueDatePicker.open()">
									<mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
									Edit
								</button>
							</div>
						</div>
					</div>
					<div class="flex-1 flex column">
						<b>Notes</b>
						<textarea
							class="full-height full-width margin-top-smallest"
							formControlName="notes"
							matInput
							style="resize: none; overflow: auto"></textarea>
					</div>
				</div>
			</div>
		</form>
	</div>
}
